import * as React from 'react';
import MatchList from "../../containers/MatchList";
import MatchListOdds from "../../containers/MatchListOdds";
import QuickBet from "../../containers/QuickBet";
import VideoArea from "../../containers/VideoArea";
import GuiHeader from './Components/GuiHeader';

const OverlaylessLayout = ( props: { serverTime: string, matchid: number } ) => {
    return (
        <div className="defaultGuiWrapper">
            <GuiHeader serverTime={props.serverTime} matchid={props.matchid} showStatsControls={false} />
            <div className="sr-grid guiContent">
                <div className="sr-cell sr-xs-1-1 sr-l-3-4 videoWrapper">
                    <div className="sr-content sr-align-center">
                        <div className="videoContent sr-content">
                            <VideoArea />
                        </div>
                    </div>
                </div>
                <div className="sr-cell sr-xs-1-1 sr-l-1-4 matchlistWrapper">
                    <div className="sr-content matchLists">
                        <QuickBet />
                        <div className="quickBet-children">
                            <MatchList />
                            <MatchListOdds />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OverlaylessLayout;
